<div class="menu-box"></div>
<div class="menu-container" [ngStyle]="{'background-color': utilService.trainerMode ? 'white':'#EFEFEF' }">
 
  <div class="menu-nav">
   
    <app-org-logo>
      
    </app-org-logo>
    <div class="schema" mat-button disabled [matMenuTriggerFor]="schema">
     <div class="schema-data"> <ion-img src="assets/images/schema1.svg" class="schema-img"></ion-img>
      <ion-label>{{selectedSchema}}</ion-label>
      </div>
      <ion-img src="assets/images/arrow_down.svg" class="arrow-img"></ion-img>
    </div>
    <div class="close-menu">
      <ion-img src="assets/images/menu.svg" (click)="utilService.closeMenu()"></ion-img>
    </div>
    <mat-menu #schema="matMenu">
      <button mat-menu-item button *ngFor="let item of schemaList" (click)="selectSchema(item)" class="menu-item">
        <div class="select-schema">
          <ion-img src="assets/images/schema1.svg"></ion-img>
          <span>{{ item }}</span>
        </div>
      </button>
    </mat-menu>

  </div>
 
  <div class="chat-container">
    <ion-button type="submit" class="new-conversation" (click)="newChat()">
      <div class="btn-content">
        <ion-img src="assets/images/add.svg"></ion-img>
        <ion-label>New conversation</ion-label>
      </div>
    </ion-button>
    <div class="old-conversation" >
      
      <div class="conv-container" *ngFor="let conversation of utilService.updatedConversations;let i=index">
        <!-- <div class="cid-box">
        <div class="cid-container"  [style.background-color]="utilService.selectedIndex === i ? '#CFCFCF' : ''">
          C{{conversation?.conversation_id}}
        </div>
        </div> -->
        <!-- <ion-icon name="arrow-forward" class="cid-icon"></ion-icon> -->
      <ion-item [ngStyle]="{'--background': utilService.selectedIndex === i ? '#CFCFCF' : 'none'}"button lines="none"  class="conversation-item">  
       
        <ion-item (click)="getMessages(conversation?.conversation_id,i,conversation?.topic)" lines="none" class="conversation-title" >
        <!-- <ion-img src="assets/images/Comment.svg" class="item-img"></ion-img> -->
       
        <!-- <ion-label>{{conversation?.topic}}</ion-label> -->
       <div class="topic-container">
        <ion-text [ngStyle]="{'background-color': utilService.trainerMode ? 'white':'#EFEFEF' }"> C{{conversation?.conversation_id}}</ion-text>
        <div style="width: 225px; max-height: 50px;color:black; font-size: 14px;font-family: 'Plus Jakarta Sans'" ellipsis [ellipsis-content]="conversation?.topic!==''?conversation?.topic:'-'"></div>
      </div>
       </ion-item>
       <div class="option-btn"  mat-button [matMenuTriggerFor]="delete" id="conv-option-btn">
        <ion-img src="assets/images/option_btn.svg" class="option-btn-img"></ion-img>
        </div>
        <mat-menu #delete="matMenu" class="snap-container">
          <button mat-menu-item  button  class="snap-item">
            <div class="select-snaps">
              <ion-img src="assets/images/snap.svg"></ion-img>
              <span>Take Snap</span>
            </div>
          </button>
          <div mat-menu-item  class="snap-item">
            <div class="view-schema">
            <div class="select-snaps">
              <ion-img src="assets/images/view_snap.svg"></ion-img>
              <span>View Snaps</span>
            </div>
              <div class="snaps" >
                <div class="snap-img" *ngFor="let snap of updatedSnaps">
                  <ion-img src="assets/images/snap.svg"></ion-img>
                  <span>{{snap}}</span>
                </div>
               
                <ion-label (click)="clickSeeMore('snaps');$event.stopPropagation()" *ngIf="!seeMoreSnaps">See More</ion-label>
                <ion-label (click)="clickSeeMore('snaps');$event.stopPropagation()" *ngIf="seeMoreSnaps">See Less</ion-label>
              </div>
          </div>
        
        </div>
        <button mat-menu-item  button class="snap-item" (click)="downloadTableToCSV(conversation?.conversation_id,i,conversation?.topic)">
          <div class="select-snaps">
            <ion-img src="assets/images/Download.svg"></ion-img>
            <span>Download</span>
          </div>
      </button>
          <button mat-menu-item (click)="setOpen(true)" button>
            <div class="select-snaps">
              <ion-img src="assets/images/trash.svg"></ion-img>
              <span>Delete</span>
            </div>
        </button>
        <ion-alert
        [isOpen]="utilService.deleteConfirmationAlert"
        header="Delete Confirmation"
        message="Are you sure you want to delete this conversation?"
        [buttons]="alertButtons"
        (didDismiss)="deleteConversation(deleteConfirm,conversation?.topic,conversation?.conversation_id,i)"
        class="custom-alert"
      ></ion-alert>
      </mat-menu>  
      </ion-item>
      </div>
      <div class="conversation-options" [ngStyle]="{'justify-content':(!seeMore&&utilService.lessConversation || seeMore&&utilService.lessConversation)?'space-between':'flex-end'}">
      <ion-item class="less-more see-more-btn" lines="none"  *ngIf="!seeMore&&utilService.lessConversation"
      (click)="clickSeeMore('conversation')">
        <ion-label class="see-more">See More</ion-label>
        <ion-img src="assets/images/arrow_down.svg"></ion-img>
      </ion-item>
      <ion-item class="less-more see-less-btn" lines="none" *ngIf="seeMore&&utilService.lessConversation" (click)="clickSeeMore('conversation')">
        <ion-label>See Less</ion-label>
        <ion-img src="assets/images/arrow_up.svg"></ion-img>
      </ion-item>
      
        <ion-label class="delete-all" *ngIf="utilService.deleteAllEnabled"  (click)="setOpenDelete(true)">Delete all</ion-label>
        <ion-alert
        [isOpen]="utilService.deleteAllConfirmationAlert"
        header="Delete Confirmation"
        message="Are you sure you want to delete all conversations?"
        [buttons]="alertAllButtons"
        (didDismiss)="deleteAllconversations(deleteAllConfirm)"
        class="custom-alert"
      ></ion-alert>
      </div>
     
    </div>
    
    
  </div>
  <div class="menu-footer">
    <div class="menu-faq">
       <ion-img src="assets/images/Group.svg" class="item-img"></ion-img>
        <ion-label>FAQs</ion-label>
    </div>
    <p>Version 1.1.0</p>
  </div>
 
  
</div>
